import { ResolveFn } from '@angular/router';

/**
 * Resolver that extracts the language from the URL path.
 * @param route - The activated route snapshot containing URL parameters and data
 * @param state - The router state containing URL and other route information
 * @returns The language code extracted from the URL path
 * @example
 * // For URL: https://pax.ch/de/some/path
 * // Returns: "de"
 */
export const languageResolver: ResolveFn<string> = (route, state) => {
    return state.url.split('/')[1];
};
